import Vue from 'vue'

export async function login(context, [name, password]) {
    try {
        context.commit('setLoading', true, { root: true })
        
        const response = await Vue.axios({
            method: 'POST',
            url: '/login',
            headers: {
              /*  'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods': 'DELETE, POST, GET, OPTIONS',
                'Access-Control-Allow-Headers': 'Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With',*/
                'Accept' : 'application/json',
                'Content-Type': 'application/json',
            },
            data: {
                name,
                password,
            }
        })
        context.commit('auth/setAccessToken', response.data.access_token, { root: true });
        context.commit('auth/setUser', response.data.user, { root: true });
        context.commit('bicis/setBicis', response.data.bicis, { root: true });
    } catch (e) {
       
        context.commit('auth/authError', e.message, { root: true })
    } finally {
        context.commit('setLoading', false, { root: true })
    }
}


export async function logOut(context, [access_token]) {
    try {
      //  context.commit('auth/logout', null, { root: true })
      //  return;
        if (access_token) {
            context.commit('setLoading', true, { root: true })

            const resuser = await Vue.axios({
                method: 'GET',
                url: '/logout',
                headers: {
                  //  'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
            })
           
            context.commit('auth/logout', resuser, { root: true })
        }

    } catch (e) {
      
        context.commit('auth/authError', e.message, { root: true })
    } finally {
        context.commit('setLoading', false, { root: true })
    }
}


